(function () {
  'use strict';

  /**
   * Stangenrabatt – Zuschnitt-Flag + lfm-Mengenberechnung
   * ------------------------------------------------------------------
   * 1. Setzt das versteckte Line-Item-Property properties[_zuschnitt] auf "1",
   *    sobald auf der Produktseite ein Zuschnitt konfiguriert ist, sonst "".
   *
   *    "Zuschnitt konfiguriert" = es gibt mindestens eine Zuschnitt-Position,
   *    deren Länge > 0 ist UND (falls ein Stückzahl-Feld dafür existiert) deren
   *    Stückzahl > 0 ist.
   *
   * 2. Berechnet bei Zuschnitt-Eingaben die Bestellmenge (1 Mengeneinheit =
   *    1 lfm) automatisch und sperrt das Mengenfeld:
   *      Menge = max(1, ceil( Σ(Stückzahl_n × Länge_n) / 1000 ))
   *    Immer AUFRUNDEN auf ganze Meter (Fachregel GF, Beleg Order
   *    11269630591244: 6071 mm müssen 7 lfm ergeben, nicht 6). KEINE
   *    6m-Stangen-Rundung — die Stangenrabatt-Function prüft %6 separat.
   *    Sobald mindestens ein Längen-Feld > 0 ist, wird das Mengenfeld
   *    readonly (+ Klasse js-qty--calculated, Plus/Minus disabled) und der
   *    Hinweistext (.js-zuschnitt-qty-note) eingeblendet; sind alle
   *    Zuschnitt-Felder wieder leer, wird das Feld wieder editierbar.
   *
   * Die Zuschnitt-Felder werden von der EasyCustomField-App server-seitig
   * INNERHALB des Produkt-Formulars gerendert (snippets/product-form.liquid,
   * {{ product.metafields.easycustomfield.customfieldsinput }}). Ihre echten
   * name-Attribute liegen in der App-Konfiguration, nicht im Theme. Die Erkennung
   * ist deshalb bewusst generisch:
   *   1. primär über name="properties[…]" (genau der Mechanismus, der die
   *      Line-Item-Property im Warenkorb erzeugt),
   *   2. als Fallback über den sichtbaren Label-Text.
   * Kein jQuery, keine Abhängigkeit von theme.js.
   *
   * Der gesetzte Flag-Wert wird server-seitig von der Stangenrabatt-Discount-
   * Function gelesen (properties[_zuschnitt]). Der Key ist im Warenkorb IMMER
   * vorhanden (live via /cart.js bestätigt): "" ohne Zuschnitt, "1" mit
   * Zuschnitt — die Function prüft daher den WERT (=== "1"), nicht die
   * Existenz des Keys.
   */

  var FLAG_SELECTOR = '.js-zuschnitt-flag';
  var FORM_SELECTOR = 'form[id^="AddToCartForm-"]';
  var QTY_SELECTOR = '.js-qty__num';
  var QTY_ADJUST_SELECTOR = '.js-qty__adjust';
  var QTY_NOTE_SELECTOR = '.js-zuschnitt-qty-note';
  var CALCULATED_CLASS = 'js-qty--calculated';

  // Schlüssel-Klassifizierung (case-insensitive, deckt Umlaut + ae/ue ab).
  var RE_ZUSCHNITT = /zuschnitt/i;
  var RE_LAENGE = /(länge|laenge|in\s*mm|\bmm\b)/i;        // Länge / Laenge / "in mm" / mm
  var RE_STUECK = /(stückzahl|stueckzahl|anzahl|menge)/i;  // Stückzahl / Stueckzahl / Anzahl / Menge
  var RE_CUTNUM = /(\d+)\s*\.\s*zuschnitt/i;                    // "1. Zuschnitt", "2. Zuschnitt", ...

  function toNumber(value) {
    if (value == null) return 0;
    var n = parseFloat(String(value).replace(',', '.'));
    return isNaN(n) ? 0 : n;
  }

  // Property-Key aus name="properties[KEY]" extrahieren, sonst null.
  function propertyKey(control) {
    var name = control.getAttribute && control.getAttribute('name');
    if (!name) return null;
    var m = name.match(/^properties\[(.+)\]$/);
    return m ? m[1] : null;
  }

  // Label-Text zu einem Control finden (label[for=…] oder umschließendes <label>).
  function labelTextFor(form, control) {
    if (control.id) {
      var safeId = (window.CSS && CSS.escape) ? CSS.escape(control.id) : control.id;
      var lbl;
      try {
        lbl = form.querySelector('label[for="' + safeId + '"]');
      } catch (e) {
        lbl = null;
      }
      if (lbl) return lbl.textContent || '';
    }
    var parentLabel = control.closest ? control.closest('label') : null;
    return parentLabel ? (parentLabel.textContent || '') : '';
  }

  // Sprechenden Schlüssel je Control ermitteln (property-Key bevorzugt, sonst Label).
  function candidateKey(form, control) {
    var key = propertyKey(control);
    if (key && RE_ZUSCHNITT.test(key)) return key;
    var labelText = labelTextFor(form, control);
    if (labelText && RE_ZUSCHNITT.test(labelText)) return labelText;
    return null;
  }

  /**
   * Zuschnitt-Felder auswerten.
   * - configured: mindestens eine Position mit Länge > 0 und (falls Stückzahl-
   *   Feld vorhanden) Stückzahl > 0  -> steuert das _zuschnitt-Flag.
   * - anyLen: mindestens ein Längen-Feld > 0 -> steuert den readonly-Zustand
   *   des Mengenfelds (greift schon, bevor die Stückzahl eingetragen ist).
   * - totalMm: Σ(Stückzahl_n × Länge_n); Positionen, bei denen ein vorhandenes
   *   Stückzahl-Feld leer/0 ist, zählen 0 (unvollständiges Paar); fehlt das
   *   Stückzahl-Feld ganz, zählt die Länge einfach (Stückzahl = 1).
   */
  function analyzeCuts(form, flagInput) {
    var controls = form.querySelectorAll('input, select, textarea');
    var groups = {};

    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (control === flagInput) continue; // eigenes Flag nicht mitzählen

      var key = candidateKey(form, control);
      if (!key) continue;

      var m = key.match(RE_CUTNUM);
      var n = m ? m[1] : '0'; // ohne Nummerierung -> Gruppe "0"
      var g = groups[n] || (groups[n] = { hasLen: false, len: 0, hasQty: false, qty: 0 });
      var val = toNumber(control.value);

      if (RE_LAENGE.test(key)) {
        g.hasLen = true;
        if (val > g.len) g.len = val;
      } else if (RE_STUECK.test(key)) {
        g.hasQty = true;
        if (val > g.qty) g.qty = val;
      }
    }

    var result = { configured: false, anyLen: false, totalMm: 0 };
    Object.keys(groups).forEach(function (n) {
      var g = groups[n];
      if (g.hasLen && g.len > 0) {
        result.anyLen = true;
        // Berechtigt, wenn Länge > 0 und (kein Stückzahl-Feld ODER Stückzahl > 0).
        if (!g.hasQty || g.qty > 0) {
          result.configured = true;
          result.totalMm += g.len * (g.hasQty ? g.qty : 1);
        }
      }
    });
    return result;
  }

  // Mengenfeld sperren/berechnen bzw. wieder freigeben.
  function applyQtyState(form, cuts) {
    var qtyInput = form.querySelector(QTY_SELECTOR);
    if (!qtyInput) return;

    var wrapper = qtyInput.closest ? qtyInput.closest('.js-qty__wrapper') : null;
    var note = form.querySelector(QTY_NOTE_SELECTOR);
    var adjustButtons = wrapper ? wrapper.querySelectorAll(QTY_ADJUST_SELECTOR) : [];
    var i;

    if (cuts.anyLen) {
      // Fachregel: aufrunden auf ganze Meter, kleinste Einheit 1 lfm.
      qtyInput.value = Math.max(1, Math.ceil(cuts.totalMm / 1000));
      qtyInput.readOnly = true;
      qtyInput.classList.add(CALCULATED_CLASS);
      if (wrapper) wrapper.classList.add(CALCULATED_CLASS);
      for (i = 0; i < adjustButtons.length; i++) {
        adjustButtons[i].disabled = true;
      }
      if (note) note.hidden = false;
    } else {
      qtyInput.readOnly = false;
      qtyInput.classList.remove(CALCULATED_CLASS);
      if (wrapper) wrapper.classList.remove(CALCULATED_CLASS);
      for (i = 0; i < adjustButtons.length; i++) {
        adjustButtons[i].disabled = false;
      }
      if (note) note.hidden = true;
    }
  }

  function wire(form) {
    var flagInput = form.querySelector(FLAG_SELECTOR);
    if (!flagInput) return;

    var sync = function () {
      var cuts = analyzeCuts(form, flagInput);
      flagInput.value = cuts.configured ? '1' : '';
      applyQtyState(form, cuts);
    };

    // Auf jede Eingabe reagieren; Capture deckt auch dynamisch eingefügte Felder ab.
    form.addEventListener('input', sync, true);
    form.addEventListener('change', sync, true);
    // Capture-Phase: läuft vor einem evtl. Submit-Handler der Options-App,
    // damit Flag UND berechnete Menge beim Serialisieren bereits korrekt stehen.
    form.addEventListener('submit', sync, true);

    // EasyCustomField rendert Felder teils asynchron nach -> nachfassen:
    // MutationObserver für nachgerenderte Felder (childList reagiert nicht auf
    // die eigenen value-/class-Änderungen von sync, keine Endlosschleife) ...
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(form, { childList: true, subtree: true });
    }
    // ... plus Timeout-Fallback für vorbefüllte Felder ohne DOM-Mutation.
    window.setTimeout(sync, 600);
    window.setTimeout(sync, 1500);
    sync();
  }

  function init() {
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) {
      wire(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
